import * as React from 'react';
import { IconArrowRight24 } from '@cian/ui-kit';

import * as style from './LastChanceDiscountContent.css';

export interface ILastChanceDiscountContentProps {
  title: string;
  label: string;
}

export const LastChanceDiscountContent: React.FC<ILastChanceDiscountContentProps> = props => {
  const { title, label } = props;

  return (
    <div className={style['container']} data-testid="LastChanceDiscountContent">
      <div className={style['label']}>{label}</div>
      <div className={style['title']}>{title}</div>
      <div className={style['button']}>
        <IconArrowRight24 color={'primary_100'} />
      </div>
    </div>
  );
};
